.sppbgv8{max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;}
